import React, { Component } from "react";
import { AppBadge, StatusBadge } from "../../components/ui";

import _ from "lodash";
import { Column } from "primereact/column";

import { toastService } from "../../services/toastService";
import { dateBodyTemplate } from "../../utils/columnTemplates";
import { KycSubmission } from "../../models/KycSubmission";
import { kycSubmissionApiService } from "../../services/api/Kyc/KycSubmissionApiService";
import { SearchRequestBaseModel, SortOrderType } from "../../models/SearchRequestModel";
import ExtendedDataTable from "../../components/ExtendedDataTable";
import { numberFilterMatchModeOptions, stringFilterMatchModeOptions } from "../Paginator";

interface KycDataProps {
    individualId: number;
    cbsId?: string;
    kycStatusTypes: Map<number, string>;
    kycStatusValue: number | undefined;
    userKycStatusClassesMap: Map<string, string>;
}

interface KycDataState {
    isLoading: boolean;
    kycSubmissions: KycSubmission[];
    isDialogVisible: boolean;
    submissionId: number;
    totalRecords: number;
}

export default class UserKycSubmissionsComponent extends Component<KycDataProps, KycDataState> {
    private dataTable: ExtendedDataTable | null = null;

    constructor(props: any) {
        super(props);

        this.state = {
            isLoading: false,
            kycSubmissions: [],
            isDialogVisible: false,
            submissionId: 0,
            totalRecords: 0,
        };
    }

    loadSubmissions = async (searchRequest: SearchRequestBaseModel) => {
        this.setState({ isLoading: true });

        const submissionResult = await kycSubmissionApiService.getAll(this.props.individualId, searchRequest);

        this.setState({ isLoading: false });
        if (!submissionResult.success) {
            toastService.error(submissionResult.message);
            return;
        }
        this.setState({ kycSubmissions: submissionResult.data, totalRecords: submissionResult.totalCount });
    };

    renderKycStatus = (status: number) => {
        const item = this.props.kycStatusTypes.get(status);
        const badge = (item != null ? this.props.userKycStatusClassesMap.get(item) : undefined) ?? "default";
        return <AppBadge variant={badge as any}>{item}</AppBadge>;
    };

    onDialogClose = (success: boolean) => {
        this.setState({ isDialogVisible: false });
        this.loadSubmissions({
            pageNumber: this.dataTable?.state.page!,
            pageSize: this.dataTable?.state.pageRowCount!,
            filters: [],
            sortings: [],
        });
    };

    onSubmissionDocumentDialogShow = (submissionId: number): void => {
        this.setState({ isDialogVisible: true, submissionId: submissionId });
    };

    // onSubmitKycDocuments = async (documents: DocumentFile[]) => {
    //     //Update this and implement "KycDocuments Save" in order to really save KYC documents.
    //     //this.setState({ kycDocuments: documents });
    //   };

    // renderAddManualKYCSubmission = (rowData: KycSubmission) => {
    //     if (this.props.kycStatusTypes.get(rowData.status!) === "New") {
    //         return <Button label="Add Manual KYC Submission" className="p-1 m-0" onClick={() => this.onSubmissionDocumentDialogShow(rowData.id)} disabled={!isUserProfileUpdateAllowed()} />
    //     }
    // }

    render() {
        return (
            <>
                <div>
                    <ExtendedDataTable
                        value={this.state.kycSubmissions}
                        loading={this.state.isLoading}
                        totalRecords={this.state.totalRecords}
                        onChange={this.loadSubmissions}
                        ref={(ref) => (this.dataTable = ref)}
                        defaultSortField="submissionTimeStamp"
                        defaultSortOrder={SortOrderType.Descending}
                    >
                        <Column
                            {...({ alwaysVisible: true } as any)}
                            field="submissionTimeStamp"
                            header="Submission TimeStamp"
                            body={dateBodyTemplate("submissionTimeStamp")}
                            filterMatchModeOptions={numberFilterMatchModeOptions}
                        ></Column>
                        <Column
                            {...({ alwaysVisible: true } as any)}
                            header="Reviewer First Name"
                            field="reviewerFirstName"
                            body={(rowData: KycSubmission) => <p>{rowData.reviewerFirstName ?? "N/A"}</p>}
                            filterMatchModeOptions={stringFilterMatchModeOptions}
                        ></Column>
                        <Column
                            {...({ alwaysVisible: true } as any)}
                            header="Reviewer Last Name"
                            field="reviewerLastName"
                            body={(rowData: KycSubmission) => <p>{rowData.reviewerLastName ?? "N/A"}</p>}
                            filterMatchModeOptions={stringFilterMatchModeOptions}
                        ></Column>
                        <Column
                            field="reviewStartedTimeStamp"
                            header="Review Started"
                            body={dateBodyTemplate("reviewStartedTimeStamp")}
                            filterMatchModeOptions={numberFilterMatchModeOptions}
                        ></Column>
                        <Column
                            field="reviewCompletedTimeStamp"
                            header="Review Closed"
                            body={dateBodyTemplate("reviewCompletedTimeStamp")}
                            filterMatchModeOptions={numberFilterMatchModeOptions}
                        />

                        <Column field="reason" header="Reason" filterMatchModeOptions={stringFilterMatchModeOptions}></Column>
                        <Column
                            field="status"
                            header="Kyc Status"
                            body={(rowData: KycSubmission) => this.renderKycStatus(rowData.status)}
                        ></Column>
                        {/* <Column
                            header=""
                            body={(rowData: KycSubmission) => this.renderAddManualKYCSubmission(rowData)}
                        ></Column> */}
                    </ExtendedDataTable>
                </div>
            </>
        );
    }
}
